import { render, staticRenderFns } from "./MA334Mobile.vue?vue&type=template&id=2fbe1daa&scoped=true&"
import script from "./MA334Mobile.vue?vue&type=script&lang=js&"
export * from "./MA334Mobile.vue?vue&type=script&lang=js&"
import style0 from "./MA334Mobile.vue?vue&type=style&index=0&id=2fbe1daa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fbe1daa",
  null
  
)

export default component.exports